import { Component, ElementRef, HostListener, Input, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

import { Chart, registerables } from 'chart.js';
import 'chartjs-adapter-date-fns';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { MondelezDataService } from 'src/app/shared/services/mondelez-data.service';
import { TimeFrameMode } from 'src/app/shared/interfaces/global-filter-model';
import { GlobalFilterService } from 'src/app/shared/services/global-filter.service';

Chart.register(...registerables);

@Component({
  selector: 'app-manufecturing-network-chart',
  templateUrl: './manufecturing-network-chart.component.html',
  styleUrls: ['./manufecturing-network-chart.component.scss'],
})
export class ManufecturingNetworkChartComponent {
  @Input() chartData: any;
  @Input() showTimeFrameModeToggle = true;

  chartObj: any;
  public fteData: any = [];
  private yearRange = {
    startYear: undefined,
    endYear: undefined,
  };
  canvasEnahanced = false;

  public timeFrameMode: TimeFrameMode = TimeFrameMode.YEARLY;
  private subs = new Subscription();

  quarterlyTicksForEachYear = [];
  @ViewChild('chartBox', { static: false }) chartBox: ElementRef;

  constructor(
    private renderer: Renderer2,
    private mondelezDataService: MondelezDataService,
    private globalFilterService: GlobalFilterService,
  ) {}

  ngOnInit(): void {
    this.subscribeData();
  }

  subscribeData() {
    this.subs.add(
      this.globalFilterService.globalFilters.subscribe((filter) => {
        if (filter) {
          this.yearRange.startYear = filter.start_year;
          this.yearRange.endYear = filter.end_year;
          if (this.timeFrameMode == 'quarter') {
            this.quarterlyTicksForEachYear = this.generateQuarterlyArray(this.yearRange.startYear, this.yearRange.endYear);
          } else {
            this.quarterlyTicksForEachYear = [];
          }
        }
      }),
    );
    // this.subs.add(
    //   this.mondelezDataService.timeFrameMode.subscribe((value) => {
    //     this.timeFrameMode = value;
    //   })
    // );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.chartObj?.destroy();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.subscribeData();
    if (changes['chartData'].currentValue != changes['chartData'].previousValue) {
      this.initLinesFteChartData();
    }
  }

  initLinesFteChartData() {
    var existingChart1 = Chart.getChart('ganttChart');
    if (existingChart1) {
      existingChart1.destroy();
    }

    let data = [];
    const quarterMonthMapping = {
      '01': '01',
      '02': '04',
      '03': '07',
      '04': '10',
    };
    this.chartData.triggers.forEach((e) => {
      const start = e.start_date ? e.start_date.split('-')[0] + '-' + quarterMonthMapping[e.start_date.split('-')[1]] : this.yearRange.endYear - 1 + '-01';
      const end = e.end_date ? e.end_date.split('-')[0] + '-' + quarterMonthMapping[e.end_date.split('-')[1]] : this.yearRange.endYear + 1 + '-01';
      data.push({
        x: [start, end],
        // y: `${e.manufacturing_network}-${e.line}`,
        y: `${e.line_code}-${e.line_description}`,
        manufacturing_logo: e.manufacturing_logo,
        line: e.line,
        ar_approved: e.ar_approved_flag,
      });
    });

    if (this.chartData && this.chartData.keys.length > 0) {
      const customPlugin = {
        id: 'imageItems',
        afterDraw: function (chart) {
          const {
            ctx,
            scales: { x, y },
          } = chart;

          chart.data.labels.forEach((label, index) => {
            let imageName = 'asteriskLogo.png';
            if (chart.data.datasets[0].data[index].manufacturing_logo) {
              imageName = chart.data.datasets[0].data[index].manufacturing_logo.toLowerCase();
            }
            const img = new Image();
            img.src = `/assets/images/Manufacturing Network-Logos/${imageName}`;
            // ctx.drawImage(img, 0, y.getPixelForValue(index) - 15, 35, 30);
          });
        },
      };

      const ctx = document.getElementById('ganttChart') as HTMLCanvasElement;
      ctx.style.backgroundColor = '#EAEAF2';

      let numberOfBars = data.length;
      const barHeight = 30;
      if (numberOfBars > 12) {
        ctx.height = numberOfBars * barHeight;
        this.canvasEnahanced = true;
      } else {
        const vh = window.innerHeight * 0.55;
        ctx.height = vh;
        this.canvasEnahanced = false;
      }

      this.chartObj = new Chart(ctx, {
        type: 'bar',
        data: {
          datasets: [
            {
              label: 'Lines',
              data: data,
              backgroundColor: '#DFDFDF',
              borderSkipped: false,
              borderRadius: 8,
              barThickness: 12,
              maxBarThickness: 20,
              barPercentage: 0.5,
              categoryPercentage: 0.5,
              datalabels: {
                display: true,
                backgroundColor: (context) => {
                  const value = context.dataset.data[context?.dataIndex];
                  if (value['ar_approved']) return '#c4d4bd';
                  else return '#747480';
                },
                borderColor: '#000',
                borderRadius: 20,
                borderWidth: 1,
                color: '#000',
                anchor: 'start',
                font: {
                  size: 12,
                  family: 'Calibri',
                  weight: 700,
                },
                padding: {
                  top: 4,
                  bottom: 4,
                  left: 6,
                  right: 6,
                },
                formatter: (value, context) => {
                  // return `${value.line}`;
                  return '   ';
                },
              },
            },
            {
              label: 'Lines2',
              data: data,
              backgroundColor: '#DFDFDF',
              borderSkipped: false,
              borderRadius: 8,
              barThickness: 12,
              maxBarThickness: 20,
              barPercentage: 0.5,
              categoryPercentage: 0.5,
              datalabels: {
                display: (context) => {
                  let point = context.dataset.data[context.dataIndex];
                  if (parseInt(point['x'][1].split('-')[0]) > this.yearRange.endYear) {
                    return false;
                  } else {
                    return true;
                  }
                },
                backgroundColor: '#F8EFDA',
                borderColor: '#000',
                borderRadius: 20,
                borderWidth: 1,
                color: '#000',
                anchor: 'end',

                font: {
                  size: 12,
                  family: 'Calibri',
                  weight: 700,
                },
                padding: {
                  top: 4,
                  bottom: 4,
                  left: 6,
                  right: 6,
                },
                formatter: (value, context) => {
                  // return `${value.line}`;
                  return '   ';
                },
              },
            },
          ],
        },
        options: {
          responsive: true,
          indexAxis: 'y',
          maintainAspectRatio: false,
          layout: {
            padding: {
              bottom: 10,
              left: 40,
              top: 10,
              right: 30,
            },
          },
          scales: {
            x: {
              offset: true,
              min: `${this.yearRange.startYear}-01`,
              max: `${this.yearRange.endYear}-10`,
              position: 'top',
              type: 'time',
              time: {
                unit: this.timeFrameMode == TimeFrameMode.YEARLY ? 'year' : 'quarter',
              },
              grid: {
                display: true,
                color: 'white',
                tickBorderDash: [5, 5],
                lineWidth: 4,
                tickLength: 16,
              },
              ticks: {
                align: 'start',
                stepSize: 1,
                padding: 5,

                font: {
                  size: 16,
                  weight: 'bold',
                  family: 'Calibri',
                },
                color: '#212121',
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                // callback: (value, index, values) => {
                //   if (this.timeFrameMode == 'year') {
                //     return moment(value).format('YYYY');
                //   } else {
                //     return '';
                //   }
                // },
              },

              border: {
                display: false,
              },
            },
            y: {
              stacked: true,
              title: {
                display: false,
                text: 'Manufacturing Network',
                font: {
                  size: 16,
                  weight: 'normal',
                },
                align: 'end',
              },
              position: 'left',
              ticks: {
                color: '#212121',
                padding: 10,
              },
              grid: {
                display: false,
              },
              border: {
                display: false,
              },
              beginAtZero: true,
              // min: 1,
              // max: 5,
              // suggestedMax: 8,
            },
          },
          plugins: {
            // scrollBar: {
            //   enable: true,
            //   scrollType: 'Vertical',
            // },
            tooltip: {
              enabled: false,
            },
            legend: {
              display: false,
            },
          },
        },
        plugins: [
          customPlugin,
          ChartDataLabels,
          {
            id: 'tickBuilder',
            beforeBuildTicks: (chart) => {
              let xAxis = chart.scales['x'];
              if (this.timeFrameMode == 'quarter') {
                xAxis.ticks = this.quarterlyTicksForEachYear;
              }
            },
          },
          {
            id: 'tickDrawer',
            beforeDraw: (chart) => {
              if (this.timeFrameMode == 'quarter') {
                let ctx = chart.ctx;
                let xAxis = chart.scales['x'];
                ctx.save();
                ((ctx.font = 'bold 16px  Calibri'), (ctx.fillStyle = 'grey'), (ctx.textAlign = 'center'), (ctx.textBaseline = 'middle'));

                this.quarterlyTicksForEachYear.forEach((tick) => {
                  let xCoord = xAxis.getPixelForValue(tick.value);
                  // Draw Ticks mark below x axis
                  ctx.beginPath();
                  ctx.moveTo(xCoord, xAxis.top);
                  ctx.lineTo(xCoord, xAxis.top);
                  ctx.strokeStyle = 'black';
                  let quarter = tick.labelForFn.split('-')[0];
                  ctx.fillText(quarter, xCoord, xAxis.top + 22);
                });

                // "Calculate the Middle Position to display Year",
                let years = [...new Set(this.quarterlyTicksForEachYear.map((item) => item.year))];

                years.forEach((year, index) => {
                  let yearTicks = this.quarterlyTicksForEachYear.filter((t) => t.year === year);

                  if (yearTicks.length > 0) {
                    let start = xAxis.getPixelForValue(yearTicks[0].value);
                    let end = xAxis.getPixelForValue(yearTicks[yearTicks.length - 1].value);
                    // if (index !== 0) {
                    let pixelDiff = (xAxis.getPixelForValue(yearTicks[1].value) - xAxis.getPixelForValue(yearTicks[0].value)) / 2;
                    ((ctx.strokeStyle = 'black'), (ctx.lineWidth = 1));
                    ctx.beginPath();
                    ctx.moveTo(start - pixelDiff, xAxis.top - 10);
                    ctx.lineTo(start - pixelDiff, xAxis.top + 30);
                    // }

                    // ctx.moveTo(end, xAxis.top - 5);
                    // ctx.lineTo(end, xAxis.top + 10);

                    ctx.stroke();
                    let middle = (start + end) / 2;

                    // Draw YEar Label
                    ((ctx.font = 'bold 16px  Calibri'), (ctx.fillStyle = 'black'), (ctx.textAlign = 'center'), (ctx.textBaseline = 'middle'));
                    ctx.fillText(year, middle, xAxis.top + 4);
                  }
                });
                ctx.restore();
              }
            },
          },
        ],
      });
    }
  }

  onTimeFrameChange(value: TimeFrameMode) {
    this.timeFrameMode = value;
    if (this.timeFrameMode == 'quarter') {
      this.quarterlyTicksForEachYear = this.generateQuarterlyArray(this.yearRange.startYear, this.yearRange.endYear);
    } else {
      this.quarterlyTicksForEachYear = [];
    }
    this.initLinesFteChartData();
  }

  generateQuarterlyArray(startYear, endYear) {
    const quarterlyArray = [];
    const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
    const quarterStartDates = ['01-01', '04-01', '07-01', '10-01'];

    for (let year = startYear; year <= endYear; year++) {
      for (let i = 0; i < quarters.length; i++) {
        const date = new Date(`${year}-${quarterStartDates[i]}T00:00:00Z`);
        const epochTime = date.getTime(); // Convert to epoch time in seconds

        quarterlyArray.push({
          value: epochTime,
          label: ``,
          labelForFn: `${quarters[i]} - ${year}`,
          major: true,
          year: year,
        });
      }
    }
    return quarterlyArray;
  }
}
